import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// Inisialisasi bahasa sebelum komponen apa pun dirender.
import './i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
// Design system Sewoork — harus diimpor terakhir agar menimpa Bootstrap & CSS komponen.
import './style/theme.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  //   <App />
  // </React.StrictMode>
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
